import "./App.css";
import {useEffect} from "react";
import faviconUrl from "@/assets/branding/favicon.svg";
import {BrowserRouter, Routes, Route} from "react-router-dom";
import {Toaster} from "./components/ui/sonner";
import Home from "./pages/Home";
import Services from "./pages/Services";
import HowItWorks from "./pages/HowItWorks";
import BecomeWorker from "./pages/BecomeWorker";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Privacy from "./pages/Privacy";

function App() {
  useEffect(() => {
    const existing = document.querySelector("link[rel='icon']");
    const link = existing || document.createElement("link");
    link.rel = "icon";
    link.type = "image/svg+xml";
    link.href = faviconUrl;
    if (!existing) {
      document.head.appendChild(link);
    }
  }, []);
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/how-it-works" element={<HowItWorks />} />
          <Route path="/become-worker" element={<BecomeWorker />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacy" element={<Privacy />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </div>
  );
}

export default App;
